export default function (state, azubiToNavigateTo) {
  return {
    ...state,
    azubiToShow: azubiToNavigateTo,
  }
}
